const stats = [
  { icon: 'ri-calendar-check-line', value: '10+', label: 'Jahre Erfahrung' },
  { icon: 'ri-building-line', value: '300+', label: 'Projekte abgeschlossen' },
  { icon: 'ri-user-smile-line', value: '200+', label: 'Zufriedene Kunden' },
  { icon: 'ri-star-line', value: '100%', label: 'Qualitätsgarantie' },
];

export default function WhyUsSection() {
  return (
    <section className="py-12 sm:py-16 bg-gray-50">
      <div className="container mx-auto px-4 sm:px-6">
        <div className="text-center mb-8 sm:mb-12">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-3 sm:mb-4">
            Warum IGM Facility Service?
          </h2>
          <p className="text-base sm:text-lg text-gray-600">
            Erfahrung, Verlässlichkeit und höchste handwerkliche Qualität
          </p>
        </div>
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-8">
          {stats.map((stat) => (
            <div
              key={stat.label}
              className="bg-white rounded-xl p-4 sm:p-8 text-center hover:shadow-lg transition-shadow border border-gray-100"
            >
              <div className="w-14 h-14 sm:w-20 sm:h-20 bg-[#0D2B4E]/10 rounded-full flex items-center justify-center mx-auto mb-3 sm:mb-6">
                <i className={`${stat.icon} text-2xl sm:text-4xl text-[#0D2B4E]`} />
              </div>
              <h3 className="text-2xl sm:text-4xl font-bold text-[#0D2B4E] mb-1 sm:mb-2">
                {stat.value}
              </h3>
              <p className="text-xs sm:text-base text-gray-700 font-medium">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
